<template>

  <div style="margin-bottom: 1em">

    <div class="navbar-brand">
      <a class="navbar-item">
        <img src="@/assets/LU Quest Long Logo_No Tag Line500x46.png">
      </a>
    </div>

    <b-message type="is-danger">
      <div class="title">
        <i class="far fa-smile"></i>&nbsp;&nbsp;&nbsp;Yay! This is a shared evaluation from {{ $store.state.session.user.firstName }} {{ $store.state.session.user.lastName }}
      </div>

      <div
        class="card"
        v-if="showDetails"
      >
        <div class="card-content">
          <div class="columns">
            <div class="column is-11">
              <div>
                <p
                  class="subtitle"
                  style="margin-bottom: 0em"
                >Accessing this shared evaluation is free. To create and manage your own evaluations, get a 14 day free trial to Quest.</p>
                <p class="is-size-7">*Only active members of Lifestyles Unlimited can subscribe</p>
              </div>
            </div>
            <div class="column">
              <a
                class="level-right"
                @click="showDetails=false"
              >
                <i class="fas fa-times"></i>
              </a>
            </div>
          </div>
          <p>With a Lifestyles Quest subscription you can:</p>

          <div class="columns">

            <div class="column">
              <ul style="margin-top: .5em">
                <li>Create your own evaluations</li>
                <li>Store documents, connections, and notes for each deal</li>
                <li>Share, export to PDF, copy, and email evaluations</li>
                <li>Analyze single and multi-family properties for investment potential</li>
              </ul>
            </div>

            <div class="column">
              <ul style="margin-top: .5em">
                <li>Manage and track your investment activities</li>
                <li>Join thousands of Lifestyles Unlimited members who benefit from Quest</li>
                <li>Get the best investments with better cash flow and more equity capture</li>
                <li>Make confident investment decisions as passive, IRO, and lead</li>
              </ul>
            </div>

          </div>

          <p>$79 per month or 20% discount for paying annually ($63 per month)</p>
          <p></p>
          <div class="level">
            <div class="level-left">
              <button class="button is-info is-large"><a
                  style="color: white"
                  href="http://www.lifestylesquest.com"
                  target="_blank"
                >LEARN MORE</a></button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <button class="button is-warning is-large"><a
                  href="http://www.quest14.com"
                  target="_blank"
                >START FREE 14 DAY TRIAL</a></button>
            </div>
          </div>

        </div>
      </div>

    </b-message>

  </div>

</template>

<script>
export default {
  data() {
    return {
      showDetails: true
    };
  }
};
</script>

<style>
</style>
